// extracted by mini-css-extract-plugin
module.exports = {"barra":"BaraAreaAlunoRelatorio_barra__3BfjB","nome":"BaraAreaAlunoRelatorio_nome__1snw2","seta":"BaraAreaAlunoRelatorio_seta__1eogB"};